<template lang="html">
  <div class="">
    <div v-if="ccb">
      <div class="title">CCB n. {{ ccb.number }}</div>
      <div class="form-group row">
        <label for="ccbDateCreated" class="col-sm-3 col-form-label">Data de emissão</label>
        <div class="col-sm-9">
          <input type="text" readonly class="form-control-plaintext" id="ccbDateCreated" :value="ccb.dateCreated | moment-complete">
        </div>
      </div>
      <div class="form-group row">
        <label for="ccbReleaseDate" class="col-sm-3 col-form-label">Data de liberação</label>
        <div class="col-sm-9">
          <input type="text" readonly class="form-control-plaintext" id="ccbReleaseDate" :value="ccb.releaseDate | moment-date">
        </div>
      </div>
      <div class="form-group row">
        <label for="ccbStatus" class="col-sm-3 col-form-label">Status Criação</label>
        <div class="col-sm-9">
          <input type="text" readonly class="form-control-plaintext" id="ccbStatus" :value="ccb.status">
        </div>
      </div>
      <div class="form-group row">
        <label for="ccbConciliationStatus" class="col-sm-3 col-form-label">Status Conciliação</label>
        <div class="col-sm-9">
          <input type="text" readonly class="form-control-plaintext" id="ccbConciliationStatus" :value="ccb.conciliationStatus">
        </div>
      </div>
      <div class="form-group row" v-if="ccb.dateCanceled">
        <label for="ccbDateCanceled" class="col-sm-3 col-form-label">Data Cancelamento</label>
        <div class="col-sm-9">
          <input type="text" readonly class="form-control-plaintext" id="ccbDateCanceled" :value="ccb.dateCanceled | moment-date">
        </div>
      </div>
      <div class="form-group row">
        <label for="ccbFdic" class="col-sm-3 col-form-label">Fundo Cessão</label>
        <div class="col-sm-9">
          <input type="text" readonly class="form-control-plaintext" id="ccbFdic" :value="ccb.fdic">
        </div>
      </div>
      <div class="form-group row" v-if="ccb.pdf">
        <label for="ccbPdf" class="col-sm-3 col-form-label">Arquivo</label>
        <div class="col-sm-9">
          <a :href="ccb.pdf" target="_blank" id="ccbPdf" class="form-control-plaintext">PDF</a>
        </div>
        <b-button @click="sendEmail(ccb.id)" variant="primary" class="px-4">Enviar Email</b-button>
        <b-button @click="sendLateEmail(ccb.id)" variant="danger" class="px-4">Enviar Email (somente para atrasados)</b-button>
      </div>
    </div>
    <div v-else>
      <div class="title">CCB não gerada</div>
    </div>
    <div>
      <div v-if="$auth.check('ROLE_SUPER') && this.$route.query.ccbforce >= 1">
        <i style="margin-left:10px;">Em caso de omissão, os valores serão os default do pedido</i><br />
        <label for="ccbForceValorParcela" class="col-sm-6 col-form-label">Valor Parcela</label>
        <div class="col-sm-6">
          <input type="text" class="form-control-plaintext" id="ccbForceValorParcela" placeholder="(Ex: 1002.50)" style="border:1px solid gray;" v-model="ccbForceValorParcela">
        </div>
        <label for="ccbForceValorIof" class="col-sm-6 col-form-label">Valor IOF</label>
        <div class="col-sm-6">
          <input type="text" class="form-control-plaintext" id="ccbForceValorIof" placeholder="(Ex: 1002.50)" style="border:1px solid gray;" v-model="ccbForceValorIof">
        </div>
        <label for="ccbForceVencimento" class="col-sm-6 col-form-label">Vencimento da primeira parcela (dd/mm/YYYY)</label>
        <div class="col-sm-6">
          <input type="text" class="form-control-plaintext" id="ccbForceVencimento" placeholder="(YYYY-mm-dd)" style="border:1px solid gray;" v-model="ccbForceVencimento">
        </div><br />
      </div>
      <div style="margin-left:10px;">
        <b-button v-if="$auth.check('ROLE_SUPER') && this.$route.query.ccbsign == 1" @click="assinarCCB(txuuid)" variant="danger" class="px-4">Forçar Assinatura CCB</b-button>
        <b-button v-if="$auth.check('ROLE_SUPER') && this.$route.query.ccbrelease == 1" @click="releaseCCB(txuuid)" variant="danger" class="px-4">Forçar Release CCB</b-button>
        <b-button v-if="$auth.check('ROLE_SUPER') && this.$route.query.ccbforce == 1" @click="forcarCCB(txuuid,1)" variant="danger" class="px-4">Forçar geração CCB (Somente Gerar)</b-button>
        <b-button v-if="$auth.check('ROLE_SUPER') && this.$route.query.ccbforce == 2" @click="forcarCCB(txuuid,2)" variant="danger" class="px-4">Forçar geração CCB, Assinar, Finalizar</b-button>
        <b-button v-if="$auth.check('ROLE_SUPER') && this.$route.query.ccbforce == 2" @click="forcarCCB(txuuid,3)" variant="danger" class="px-4">Forçar geração CCB, Assinar, Finalizar e Liberar</b-button>
        <b-button v-if="$auth.check('ROLE_SUPER') && this.$route.query.ccbcancel == 1" @click="cancelCCB(txuuid)" variant="danger" class="px-4">Cancelar somente CCB</b-button>
        <b-button v-if="$auth.check('ROLE_SUPER') && this.$route.query.ccbcheck == 1" @click="diagnosticarCCB(txuuid)" variant="warning" class="px-4">Diagnosticar Transaction</b-button>
      </div>
      <json-viewer :value="jsonData"></json-viewer>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
// import jQuery from 'jquery/dist/jquery.js'
import JsonViewer from 'vue-json-viewer'

Vue.use(JsonViewer)

export default {
  data: function () {
    return {ccbForceValorParcela: null, ccbForceValorIof: null, ccbForceVencimento: null}
  },
  props: ['ccb', 'txuuid', 'jsonData'],
  methods: {
    forcarCCB (txuuid, versao) {
      if (!confirm('Tem certeza de que deseja forçar a GERAÇÂO de CCB na MoneyPlus para esta transação?')) {
        return false
      }
      console.log(this.ccbForceValorParcela)
      this.$http.post('api/ccb/' + txuuid + '/forcebmp/' + versao, {valorParcela: this.ccbForceValorParcela, valorIof: this.ccbForceValorIof, vencimento: this.ccbForceVencimento})
        .then(function (res) {
          console.log(res)
          var classe = ''
          var msg = ''
          var titulo = ''
          if (res.body.error) {
            titulo = 'Erro!'
            classe = 'danger'
            msg = res.body.error
          } else {
            titulo = 'OK!'
            classe = 'success'
            msg = res.body.msg
          }
          this.$bvToast.toast(msg, {
            title: titulo,
            autoHideDelay: 5000,
            variant: classe
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res.data, {
            title: 'Erro ao executar a tarefa',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    },
    releaseCCB (txuuid) {
      if (!confirm('Tem certeza de que deseja forçar o RELEASE da CCB na MoneyPlus para esta transação?')) {
        return false
      }
      this.$http.get('api/ccb/' + txuuid + '/forcereleasebmp')
        .then(function (res) {
          console.log(res)
          var classe = ''
          var msg = ''
          var titulo = ''
          if (res.body.error) {
            titulo = 'Erro!'
            classe = 'danger'
            msg = res.body.error
          } else {
            titulo = 'OK!'
            classe = 'success'
            msg = res.body.msg
          }

          this.$bvToast.toast(msg, {
            title: titulo,
            autoHideDelay: 5000,
            variant: classe
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res.body.data, {
            title: 'Erro ao executar a tarefa',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    },
    assinarCCB (txuuid) {
      if (!confirm('Tem certeza de que deseja forçar a ASSINATURA da CCB na MoneyPlus para esta transação?')) {
        return false
      }
      this.$http.get('api/ccb/' + txuuid + '/forceassinaturabmp')
        .then(function (res) {
          console.log(res)
          var classe = ''
          var msg = ''
          var titulo = ''
          if (res.body.error) {
            titulo = 'Erro!'
            classe = 'danger'
            msg = res.body.error
          } else {
            titulo = 'OK!'
            classe = 'success'
            msg = res.body.msg
          }
          this.$bvToast.toast(msg, {
            title: titulo,
            autoHideDelay: 5000,
            variant: classe
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res.data, {
            title: 'Erro ao executar a tarefa',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    },
    diagnosticarCCB (txuuid) {
      this.$bvToast.toast('Rodando diagnóstico...', {
        title: 'Aguarde...',
        autoHideDelay: 5000,
        variant: 'warning'
      })
      this.$http.get('api/ccb/' + txuuid + '/diagnostico')
        .then(function (res) {
          console.log(res)

          var titulo = 'Finalizado'
          var classe = 'success'
          var msg = 'Diagnóstico finalizado'
          this.jsonData = res.body

          this.$bvToast.toast(msg, {
            title: titulo,
            autoHideDelay: 5000,
            variant: classe
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res.data, {
            title: 'Erro ao executar a tarefa',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    },
    cancelCCB (txuuid) {
      if (!confirm('Tem certeza de que deseja CANCELAR SOMENTE a CCB na MoneyPlus para esta transação?\nÉ altamente recomendado usar a funcionalidade Cancelar padrão do sistema para cancelar todos os pontos (boletos, registros bf, etc).')) {
        return false
      }
      this.$http.get('api/ccb/' + txuuid + '/cancelccbbmp')
        .then(function (res) {
          console.log(res)
          var classe = ''
          var msg = ''
          var titulo = ''
          if (res.body.error) {
            titulo = 'Erro!'
            classe = 'danger'
            msg = res.body.error
          } else {
            titulo = 'OK!'
            classe = 'success'
            msg = res.body.msg
          }
          this.$bvToast.toast(msg, {
            title: titulo,
            autoHideDelay: 5000,
            variant: classe
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res.data, {
            title: 'Erro ao executar a tarefa',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    },
    sendEmail (id) {
      this.$http.get('api/ccb/' + id + '/sendEmail')
        .then(function (res) {
          console.log(res)
          this.$bvToast.toast(res.data, {
            title: 'E-mail enviado com sucesso',
            autoHideDelay: 5000,
            variant: 'primary'
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res.data, {
            title: 'Erro ao enviar email',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    },
    sendLateEmail (id) {
      this.$http.get('api/ccb/' + id + '/sendLateEmail')
        .then(function (res) {
          console.log(res)
          this.$bvToast.toast(res.data, {
            title: 'E-mail enviado com sucesso',
            autoHideDelay: 5000,
            variant: 'primary'
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res.data, {
            title: 'Erro ao enviar email',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    }
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/partial/cards/loans/LoanDetails.vue